declare const window: any;

const TRACKING_SESSION_FLAG = 'alertnow_tracking_initialized';
const ATTR_SESSION_KEY = 'marketing_attribution';

function saveMarketingAttribution(): void {
  try {
    const params = new URLSearchParams(window.location.search);
    const attribution: any = {
      utm_source: params.get('utm_source'),
      utm_medium: params.get('utm_medium'),
      utm_campaign: params.get('utm_campaign'),
      utm_content: params.get('utm_content'),
      referrer: document.referrer || null,
      landing_page: window.location.pathname
    };

    if (attribution.utm_source || attribution.utm_medium || attribution.utm_campaign) {
      sessionStorage.setItem(ATTR_SESSION_KEY, JSON.stringify(attribution));
    }
  } catch (e) {
    console.warn('saveMarketingAttribution error', e);
  }
}

function waitForPosthog(timeout = 5000): Promise<any> {
  return new Promise((resolve) => {
    const start = Date.now();
    (function check() {
      if (window && window.posthog) return resolve(window.posthog);
      if (Date.now() - start > timeout) return resolve(null);
      requestAnimationFrame(check);
    })();
  });
}

export async function initPosthogTracking(companyNameParam: String): Promise<void> {

  if (sessionStorage.getItem(TRACKING_SESSION_FLAG)) {
    console.log('PostHog tracking already initialized in this session');
    return;
  }

  saveMarketingAttribution();

  const posthogLib = await waitForPosthog();
  if (!posthogLib) {
    console.warn('PostHog not loaded, skipping tracking init');
    return;
  }

  try {
    const user = global['loginUser'];
    if (!user) {
      console.warn('No loginUser provided to initPosthogTracking');
      return;
    }

    const companyId = user.curCmpnId;
    const companyName = companyNameParam;
    const siteCode = user.siteCd;
    if (companyId) {
      window.posthog.group('company', String(companyId), {
        name: companyName,
        site_code: siteCode
      });
    }

    const saved = sessionStorage.getItem(ATTR_SESSION_KEY);
    const attribution = saved ? JSON.parse(saved) : {};
    const userRole= global['userRole'];
    const distinctId = userRole.userId;
    if (distinctId) {
      const identifyProps: any = {
        email: user.userEmail,
        role: userRole.roleCd,
        site_code: siteCode,
        mfa_enabled: user.mfaYn === 'Y',
        ...attribution
      };

      window.posthog.identify(String(distinctId), identifyProps);
    } else {
      console.warn('No user ID found for posthog.identify');
    }

    sessionStorage.setItem(TRACKING_SESSION_FLAG, '1');
  } catch (err) {
    console.error('initPosthogTracking error', err);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/src/3rdPartyScript/posthog-tracking.ts